import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import barIcon from "../../asessts/Images/bar_icon.svg";
import profileIcon from "../../asessts/Images/profile_user_icon.svg";
import logoutIcon from "../../asessts/Images/logout_icon.svg";
import { fetchAndSetAdminData } from "../../services/AdminService";
import { clearAdminData } from "../../redux/slices/AdminSlice";
import LogoutPopup from "./LogoutPopup";
import { ShimmerCircularImage } from "react-shimmer-effects";
import { setSideBar } from "../../redux/slices/SidebarSlice";
function Header({ title }) {
  const dropdownRef = useRef(null);
  const adminData = useSelector((state) => state.adminSlice.adminData);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLogoutPopup, setIsLogoutPopup] = useState(false);
  const dispatch = useDispatch();

  const sideBarSlice = useSelector((state) => state.sideBarSlice.sideBar);

  const toggleSidebar = () => {
    dispatch(setSideBar(!sideBarSlice));
  };

  useEffect(() => {
    if (!adminData.firstName) {
      const token = localStorage.getItem("careToken");
      if (token) {
        fetchAndSetAdminData(token, dispatch);
      }
    }
  }, [dispatch, adminData.firstName]);

  const toggleDropdown = (event) => {
    event.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("careCred");
    localStorage.removeItem("careToken");
    localStorage.clear();
    window.location.href = "/";
    dispatch(clearAdminData());
  };

  const handlePopupOpen = (e) => {
    e.preventDefault();
    setIsLogoutPopup(true);
  };

  const handlePopupClose = (e) => {
    e.preventDefault();
    setIsLogoutPopup(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="dashboard-header">
      <div className="bar-btn-mobile" onClick={toggleSidebar}>
        <span>
          <img src={barIcon} alt="" />
        </span>
      </div>
      <div className="dashboard-heading">
        <h2>{title}</h2>
      </div>
      <div className="logo-mobile">
        <img src="images/Login_new_logo.png" alt="" />
      </div>
      <div className="profile-picture">
        <div className="profile-img" ref={dropdownRef}>
          {adminData?.image ? (
            <a>
              <img
                src={adminData.image}
                alt="profile image"
                onClick={toggleDropdown}
              />
            </a>
          ) : (
            <ShimmerCircularImage size={50} />
          )}
          {isDropdownOpen && (
            <div className="profile-dropdown">
              <div className="profile-info">
                <div className="profile-image">
                  {adminData?.image ? (
                    <img
                      src={adminData.image}
                      alt="profile image"
                      onClick={toggleDropdown}
                    />
                  ) : (
                    <ShimmerCircularImage size={80} />
                  )}
                </div>
                <h3>{`${adminData.firstName} ${adminData.lastName}`}</h3>
                <span>{adminData.email}</span>
              </div>
              <div className="log-out">
                <ul>
                  <li>
                    <Link to="/setting" className="profile-btn">
                      <img src={profileIcon} alt="" />
                      My Profile
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="profile-btn"
                      onClick={handlePopupOpen}
                    >
                      <img src={logoutIcon} alt="" />
                      Logout
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {isLogoutPopup && (
            <LogoutPopup
              handleLogout={handleLogout}
              handlePopupClose={handlePopupClose}
              isLogoutPopup={isLogoutPopup}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
